import { getComputedIsEverythingSelectedInTable, getSelectedTableView } from 'owa-mail-list-store';
import loc, { format } from 'owa-localize';
import isWin32StylingEnabled from 'owa-theme-win32-style-store/lib/selectors/isWin32StylingEnabled';

import Archive from 'owa-fluent-icons-svg/lib/icons/ArchiveRegular';
import ArchiveSettings from 'owa-fluent-icons-svg/lib/icons/ArchiveSettingsRegular';
import ArrowForward from 'owa-fluent-icons-svg/lib/icons/ArrowForwardRegular';
import ArrowReply from 'owa-fluent-icons-svg/lib/icons/ArrowReplyRegular';
import ArrowReplyAll from 'owa-fluent-icons-svg/lib/icons/ArrowReplyAllRegular';
import CalendarReply from 'owa-fluent-icons-svg/lib/icons/CalendarReplyRegular';
import CalendarSparkleRegular from 'owa-fluent-icons-svg/lib/icons/CalendarSparkleRegular';
import CopyArrowRightRegular from 'owa-fluent-icons-svg/lib/icons/CopyArrowRightRegular';
import type { ControlInfo } from './controlInfo';
import Delete from 'owa-fluent-icons-svg/lib/icons/DeleteRegular';
import { deleteItem as DeleteStrings_deleteItem } from 'owa-locstrings/lib/strings/deleteitem.locstring.json';
import { messageRecall } from 'owa-locstrings/lib/strings/messagerecall.locstring.json';
import Flag from 'owa-fluent-icons-svg/lib/icons/FlagRegular';
import FolderArrowRight from 'owa-fluent-icons-svg/lib/icons/FolderArrowRightRegular';
import FolderMail from 'owa-fluent-icons-svg/lib/icons/FolderMailRegular';
import ImmersiveReader from 'owa-fluent-icons-svg/lib/icons/ImmersiveReaderRegular';
import { junk as JunkStrings_junk } from 'owa-locstrings/lib/strings/junk.locstring.json';
import MailAttachRegular from 'owa-fluent-icons-svg/lib/icons/MailAttachRegular';
import MailCheckmarkRegular from 'owa-fluent-icons-svg/lib/icons/MailCheckmarkRegular';
import Broom from 'owa-fluent-icons-svg/lib/icons/BroomRegular';
import MailRead from 'owa-fluent-icons-svg/lib/icons/MailReadRegular';
import MailReadMultipleRegular from 'owa-fluent-icons-svg/lib/icons/MailReadMultipleRegular';
import { type MailRibbonControlId } from 'owa-ribbon-ids/lib/mailRibbonId';
import type { MailboxInfo } from 'owa-client-types';
import { isUnifiedInboxMailboxInfo } from 'owa-client-types/lib/UnifiedInboxMailboxInfo';
import { type MenuItemType } from 'owa-filterable-menu/lib/components/MenuItemType';
import { neverBlockSender as NeverBlockSenderStrings_neverBlockSender } from 'owa-locstrings/lib/strings/neverblocksender.locstring.json';
import { notJunk as NotJunkStrings_notJunk } from 'owa-locstrings/lib/strings/notjunk.locstring.json';
import PersonAvailableRegular from 'owa-fluent-icons-svg/lib/icons/PersonAvailableRegular';
import PersonProhibitedRegular from 'owa-fluent-icons-svg/lib/icons/PersonProhibitedRegular';
import Print from 'owa-fluent-icons-svg/lib/icons/PrintRegular';
import Prohibited from 'owa-fluent-icons-svg/lib/icons/ProhibitedRegular';
import ShieldTaskRegular from 'owa-fluent-icons-svg/lib/icons/ShieldTaskRegular';
import { reportJunk as ReportJunkStrings_reportJunk } from 'owa-locstrings/lib/strings/reportjunk.locstring.json';
import { reportPhishing as ReportPhishingStrings_reportPhishing } from 'owa-locstrings/lib/strings/reportphishing.locstring.json';
import type {
    RibbonControlDefinitionProps,
    ReadOnlyRibbonControlDefProps,
} from './RibbonControlDefinitionProps';
import type { RibbonControlId } from 'owa-ribbon-ids';
import { getHoverTooltip } from './HoverTooltips/hoverTooltipConfig';
import { isReportPhishingSupportedForUnifiedInboxSelection } from './isReportPhishingSupportedForUnifiedInboxSelection';
import Settings from 'owa-fluent-icons-svg/lib/icons/SettingsRegular';
import ShieldErrorRegular from 'owa-fluent-icons-svg/lib/icons/ShieldErrorRegular';
import {
    block_SplitButton as SplitButtonStrings_block_SplitButton,
    delete_SplitButton as SplitButtonStrings_delete_SplitButton,
    flagUnflag_SplitButton as SplitButtonStrings_flagUnflag_SplitButton,
    replyCopilotMeetingToEmail_SplitButton as SplitButtonStrings_replyCopilotMeetingToEmail_SplitButton,
    report_SplitButton as SplitButtonStrings_report_SplitButton,
    respondForward_SplitButton as SplitButtonStrings_respondForward_SplitButton,
    respond_SplitButton as SplitButtonStrings_respond_SplitButton,
} from './ribbon_mail_split_buttons.locstring.json';
import {
    archiveEmail_Button as Strings_archiveEmail_Button,
    assignPolicy_FlyoutButton as Strings_assignPolicy_FlyoutButton,
    assignPolicy_FlyoutButton_MLR as Strings_assignPolicy_FlyoutButton_MLR,
    blockSender_Button as Strings_blockSender_Button,
    block_Button as Strings_block_Button,
    categorize_FlyoutButton as Strings_categorize_FlyoutButton,
    createRule_Button as Strings_createRule_Button,
    getMessageExtensions_Button as Strings_getMessageExtensions_Button,
    ignoreEmail_Button as Strings_ignoreEmail_Button,
    immersiveReader_Button as Strings_immersiveReader_Button,
    manageQuickSteps_Button as Strings_manageQuickSteps_Button,
    manageRules_Button as Strings_manageRules_Button,
    markAllAsRead_Button as Strings_markAllAsRead_Button,
    moreRetentionPoliciesOptions_Button as Strings_moreRetentionPoliciesOptions_Button,
    move_FlyoutButton as Strings_move_FlyoutButton,
    move_FlyoutButton_MLR as Strings_move_FlyoutButton_MLR,
    notJunk_Button as Strings_notJunk_Button,
    pinUnpin_Button as Strings_pinUnpin_Button,
    pinUnpin_Button_MLR as Strings_pinUnpin_Button_MLR,
    printMail_Button as Strings_printMail_Button,
    quickSteps_Button as Strings_quickSteps_Button,
    quickSteps_MenuLauncherLabel as Strings_quickSteps_MenuLauncherLabel,
    readUnread_Button as Strings_readUnread_Button,
    replyAllToEmail_Button as Strings_replyAllToEmail_Button,
    replyCopilotMeetingToEmail_Button as Strings_replyCopilotMeetingToEmail_Button,
    replyCopilotMeetingToEmail_Button_Tooltip as Strings_replyCopilotMeetingToEmail_Button_Tooltip,
    replyForwardEmailAsAttachment_Button as Strings_replyForwardEmailAsAttachment_Button,
    replyForwardEmail_Button as Strings_replyForwardEmail_Button,
    replyMeetingToEmail_Button as Strings_replyMeetingToEmail_Button,
    replyToEmail_Button as Strings_replyToEmail_Button,
    report_Button as Strings_report_Button,
    rules_FlyoutButton as Strings_rules_FlyoutButton,
    snooze_Button as Strings_snooze_Button,
    stopIgnoringEmail_Button as Strings_stopIgnoringEmail_Button,
    sweepEmail_Button as Strings_sweepEmail_Button,
    zoom_Button as Strings_zoom_Button,
} from 'owa-locstrings/lib/strings/ribbon_mail_buttons_and_tabs.locstring.json';
import {
    deleteEmptyFolderButtonDesc as StringsToolTip_deleteEmptyFolderButtonDesc,
    junkButtonDesc as StringsToolTip_junkButtonDesc,
    markAllAsReadDesc as StringsToolTip_markAllAsReadDesc,
} from './HoverTooltips/hoverTooltipDesc.locstring.json';
import {
    flagAddReminder_Button as FlagStrings_flagAddReminder_Button,
    flagClearFlag_Button as FlagStrings_flagClearFlag_Button,
    flagCompleteCustom_Button as FlagStrings_flagCompleteCustom_Button,
    flagCompleteNextWeek_Button as FlagStrings_flagCompleteNextWeek_Button,
    flagCompleteNoDate_Button as FlagStrings_flagCompleteNoDate_Button,
    flagCompleteThisWeek_Button as FlagStrings_flagCompleteThisWeek_Button,
    flagCompleteToday_Button as FlagStrings_flagCompleteToday_Button,
    flagCompleteTomorrow_Button as FlagStrings_flagCompleteTomorrow_Button,
    flagEditReminder_Button as FlagStrings_flagEditReminder_Button,
    flagMarkComplete_Button as FlagStrings_flagMarkComplete_Button,
    flagUnflag_Button as FlagStrings_flagUnflag_Button,
    flagUnflag_Button_MLR as FlagStrings_flagUnflag_Button_MLR,
    followUp_Button as FlagStrings_followUp_Button,
} from './ribbon_mail_flag_buttons.locstring.json';
import Tag from 'owa-fluent-icons-svg/lib/icons/TagRegular';
import MailRewindRegular from 'owa-fluent-icons-svg/lib/icons/MailRewindRegular';
import { owaComputedFn } from 'owa-computed-fn';
import { getComputedEmptyFolderText } from 'owa-mail-list-store/lib/utils/getEmptyFolderText';
import { getMailMenuItemShouldShow } from 'owa-mail-filterable-menu-behavior';
import { getRibbonMailboxInfo } from './getRibbonMailboxInfo';
import folderIdToName from 'owa-session-store/lib/utils/folderIdToName';
import isReplyAllTheDefaultResponse from 'owa-mail-reading-pane-store/lib/utils/isReplyAllTheDefaultResponse';
import { getAccountScopeUserSettings } from 'owa-session-store/lib/selectors/getAccountScopeUserSettings';
import ZoomInRegular from 'owa-fluent-icons-svg/lib/icons/ZoomInRegular';
import { isSingleLineRibbon } from 'owa-command-ribbon-store/lib/selectors/isSingleLineRibbon';
import EyeFilled from 'owa-fluent-icons-svg/lib/icons/EyeFilled';
import { trackReadReceipts } from 'owa-track-read-receipts/lib/strings/trackReadReceipts.locstring.json';
import ChatRegular from 'owa-fluent-icons-svg/lib/icons/ChatRegular';
import { TeamsColor } from 'owa-ribbon-brand-icons/lib/icons/TeamsColor';
import {
    Teams_ChatAroundEmailFlyoutButton as RibbonMailStrings_Teams_ChatAroundEmailFlyoutButton,
    allApps_Button as RibbonMailStrings_allApps_Button,
    copyToButton as RibbonMailStrings_copyToButton,
    createQuickStep_Button as RibbonMailStrings_createQuickStep_Button,
    scanButton as RibbonMailStrings_scanButton,
    teams_ChatAroundEmailAllButton as RibbonMailStrings_teams_ChatAroundEmailAllButton,
    teams_ChatAroundEmailButton as RibbonMailStrings_teams_ChatAroundEmailButton,
    teams_ShareToTeamsChatButton as RibbonMailStrings_teams_ShareToTeamsChatButton,
    unreadRead_Button as RibbonMailStrings_unreadRead_Button,
} from './ribbon_mail_strings.locstring.json';
import { getItem } from './getItem';
import { isItemInFolder } from './isItemInFolder';
import type { ClientItem } from 'owa-mail-store';
import type { ClientItemId } from 'owa-client-ids';
import { resend } from 'owa-message-resend/lib/strings/resend.locstring.json';
import MailArrowClockwiseRegular from 'owa-fluent-icons-svg/lib/icons/MailArrowClockwiseRegular';
import AppFolderRegular from 'owa-fluent-icons-svg/lib/icons/AppFolderRegular';
import { type ActionControlId } from 'owa-ribbon-ids/lib/actionControlId';
import FlashRegular from 'owa-fluent-icons-svg/lib/icons/FlashRegular';
import Clock from 'owa-fluent-icons-svg/lib/icons/ClockRegular';
import Unpin from 'owa-fluent-icons-svg/lib/icons/PinRegular';
import SpeakerMuteRegular from 'owa-fluent-icons-svg/lib/icons/SpeakerMuteRegular';
import AddRegular from 'owa-fluent-icons-svg/lib/icons/AddRegular';

/**
 * Retrieves the display information pertaining to a given mail ribbon
 * control
 * @param controlId for which to retrieve the display information for
 * @param props the definition props
 * @returns display information for passed in control
 */
export function getSharedControlInfo(
    controlId: RibbonControlId,
    props: RibbonControlDefinitionProps
): ControlInfo {
    const mailboxInfo = getRibbonMailboxInfo(props.mailboxInfo);
    switch (controlId) {
        //home tab controls
        case 679:
        case 556: {
            const controlName: string = loc(Strings_replyToEmail_Button);

            return {
                iconName: ArrowReply,
                text: controlName,
                tooltip: getHoverTooltip(controlId, controlName),
            };
        }

        case 519: {
            let controlName: string;
            let tooltip: string | undefined;
            if (props.isPopout) {
                controlName = loc(DeleteStrings_deleteItem);
                tooltip = getHoverTooltip(controlId, controlName);
            } else {
                const isEverythingSelectedInTable = getComputedIsEverythingSelectedInTable();
                if (isEverythingSelectedInTable || getMailMenuItemShouldShow(13, mailboxInfo)) {
                    controlName = getComputedEmptyFolderText();
                    tooltip = getHoverTooltip(controlId, controlName, {
                        description: loc(StringsToolTip_deleteEmptyFolderButtonDesc),
                    });
                } else {
                    controlName = loc(DeleteStrings_deleteItem);
                    tooltip = getHoverTooltip(controlId, controlName);
                }
            }

            const controlSplitBtn: string = loc(SplitButtonStrings_delete_SplitButton);

            return {
                iconName: Delete,
                text: controlName,
                ariaText: controlSplitBtn,
                tooltip,
            };
        }

        case 505: {
            const controlName: string = loc(Strings_archiveEmail_Button);

            return {
                iconName: Archive,
                text: controlName,
                tooltip: getHoverTooltip(controlId, controlName),
            };
        }

        case 535: {
            // Determine if current folder is other than Junk
            const itemId: ClientItemId | undefined = (props as ReadOnlyRibbonControlDefProps)
                ?.itemId;
            const item: ClientItem | undefined = getItem(itemId);

            const notIsJunkFolder = props.isPopout
                ? !item || !isItemInFolder(item, ['junkemail'])
                : isUnifiedInboxMailboxInfo(mailboxInfo)
                ? item
                    ? !isItemInFolder(item, ['junkemail'])
                    : folderIdToName(getSelectedTableView()?.tableQuery?.folderId ?? '') !==
                      'junkemail'
                : getMailMenuItemShouldShow(24, mailboxInfo) ||
                  !getMailMenuItemShouldShow(55, mailboxInfo);

            // If we are in the Junk Folder (i.e. notIsJunkFolder is false) the label "Not junk" will be shown.
            const controlName: string = notIsJunkFolder
                ? loc(ReportJunkStrings_reportJunk)
                : loc(Strings_notJunk_Button);

            let iconName;
            let tooltip;

            if (notIsJunkFolder) {
                iconName = Prohibited;
                tooltip = getHoverTooltip(535, controlName);
                if (tooltip) {
                    tooltip = format(tooltip, loc(JunkStrings_junk).toLowerCase());
                }
            } else {
                iconName = MailCheckmarkRegular;
                tooltip = format(
                    loc(StringsToolTip_junkButtonDesc),
                    loc(NotJunkStrings_notJunk).toLowerCase()
                );
            }

            return {
                iconName,
                text: controlName,
                tooltip,
            };
        }

        case 657: {
            const isUnifiedInbox = isUnifiedInboxMailboxInfo(mailboxInfo);
            const controlName: string = loc(Strings_report_Button);
            // For unified inbox, the ReportSplit button's primary action mirrors the
            // non-unified behavior: "Report phishing" when the selected account supports it,
            // otherwise "Junk / Not Junk".
            if (isUnifiedInbox) {
                const reportControlAria: string = loc(SplitButtonStrings_report_SplitButton);

                if (
                    isReportPhishingSupportedForUnifiedInboxSelection(
                        props as ReadOnlyRibbonControlDefProps
                    )
                ) {
                    let tooltip = getHoverTooltip(657, controlName);
                    if (tooltip) {
                        tooltip = format(tooltip, loc(JunkStrings_junk).toLowerCase());
                    }

                    return {
                        iconName: ShieldErrorRegular,
                        text: controlName,
                        ariaText: reportControlAria,
                        tooltip,
                    };
                }

                const itemId: ClientItemId | undefined = (props as ReadOnlyRibbonControlDefProps)
                    ?.itemId;
                const item: ClientItem | undefined = getItem(itemId);

                const notIsJunkFolder = item
                    ? !isItemInFolder(item, ['junkemail'])
                    : folderIdToName(getSelectedTableView()?.tableQuery?.folderId ?? '') !==
                      'junkemail';

                let tooltip;

                if (notIsJunkFolder) {
                    tooltip = getHoverTooltip(535, controlName);
                    if (tooltip) {
                        tooltip = format(tooltip, loc(JunkStrings_junk).toLowerCase());
                    }
                } else {
                    tooltip = format(
                        loc(StringsToolTip_junkButtonDesc),
                        loc(NotJunkStrings_notJunk).toLowerCase()
                    );
                }

                return {
                    iconName: ShieldErrorRegular,
                    text: controlName,
                    ariaText: reportControlAria,
                    tooltip,
                };
            }

            const isCloudCache =
                /* eslint-disable-next-line no-restricted-properties  -- (https://aka.ms/OWALintWiki)
                 * Adding IsShadowMailbox to restricted properties/methods.
                 *	> 'IsShadowMailbox' is restricted from being used. IsCloudCache/IsShadowMailbox should be resolved in ECS as a filter in a feature flight if possible. */
                !!getAccountScopeUserSettings(mailboxInfo)?.SessionSettings?.IsShadowMailbox;

            let tooltip = isCloudCache
                ? getHoverTooltip(535, controlName)
                : getHoverTooltip(657, controlName);

            if (tooltip) {
                tooltip = format(tooltip, loc(JunkStrings_junk).toLowerCase());
            }

            const reportControlAria: string = loc(SplitButtonStrings_report_SplitButton);

            return {
                iconName: ShieldErrorRegular,
                text: controlName,
                ariaText: reportControlAria,
                tooltip,
            };
        }

        case 547: {
            const controlName: string = loc(ReportPhishingStrings_reportPhishing);
            const tooltip = getHoverTooltip(controlId, controlName);
            return {
                iconName: ShieldErrorRegular,
                text: controlName,
                tooltip,
            };
        }

        case 507: {
            const controlName: string = loc(Strings_blockSender_Button);

            return {
                iconName: PersonProhibitedRegular,
                text: controlName,
                tooltip: getHoverTooltip(controlId, controlName),
            };
        }

        case 658: {
            const controlName: string = loc(Strings_block_Button);
            const blockControlAria: string = loc(SplitButtonStrings_block_SplitButton);

            return {
                iconName: PersonProhibitedRegular,
                text: controlName,
                ariaText: blockControlAria,
                tooltip: getHoverTooltip(controlId, controlName),
            };
        }

        case 659: {
            const controlName: string = loc(NeverBlockSenderStrings_neverBlockSender);

            return {
                iconName: PersonAvailableRegular,
                text: controlName,
                tooltip: getHoverTooltip(controlId, controlName),
            };
        }

        case 559: {
            const controlName: string = loc(Strings_rules_FlyoutButton);

            return {
                iconName: FolderMail,
                text: controlName,
                tooltip: getHoverTooltip(controlId, controlName),
            };
        }

        case 557:
        case 681: {
            const controlName: string = loc(Strings_replyAllToEmail_Button);

            return {
                iconName: ArrowReplyAll,
                text: controlName,
                tooltip: getHoverTooltip(controlId, controlName),
            };
        }

        case 678: {
            const isReplyAll = isReplyAllTheDefaultResponse();
            const controlSplitBtn: string = loc(SplitButtonStrings_respond_SplitButton);

            return {
                iconName: isReplyAll ? ArrowReplyAll : ArrowReply,
                text: isReplyAll
                    ? loc(Strings_replyAllToEmail_Button)
                    : loc(Strings_replyToEmail_Button),
                ariaText: controlSplitBtn,
                tooltip: isReplyAll
                    ? getHoverTooltip(557, loc(Strings_replyAllToEmail_Button))
                    : getHoverTooltip(556, loc(Strings_replyToEmail_Button)),
            };
        }

        case 555:
        case 680: {
            const controlName: string = loc(Strings_replyForwardEmail_Button);
            const isRespondForwardControl = controlId === 555;
            const controlSplitBtn: string = loc(SplitButtonStrings_respondForward_SplitButton);

            return {
                iconName: ArrowForward,
                text: controlName,
                ariaText: isRespondForwardControl ? controlSplitBtn : undefined,
                tooltip: getHoverTooltip(controlId, controlName),
            };
        }
        case 651: {
            const controlName: string = loc(Strings_replyForwardEmailAsAttachment_Button);

            return {
                iconName: MailAttachRegular,
                text: controlName,
                ariaText: controlName,
                tooltip: getHoverTooltip(controlId, controlName),
            };
        }

        case 700:
        case 553: {
            const controlName: string = loc(Strings_replyMeetingToEmail_Button);

            const tooltipText = getHoverTooltip(controlId, controlName);

            return {
                iconName: CalendarReply,
                text: controlName,
                tooltip: tooltipText,
            };
        }

        case 699:
        case 698: {
            const controlName: string = loc(Strings_replyCopilotMeetingToEmail_Button);
            const tooltipText = loc(Strings_replyCopilotMeetingToEmail_Button_Tooltip);
            const ariaText: string = loc(SplitButtonStrings_replyCopilotMeetingToEmail_SplitButton);
            return {
                iconName: CalendarSparkleRegular,
                text: controlName,
                ariaText,
                tooltip: tooltipText,
            };
        }

        case 696: {
            const controlName: string = loc(Strings_replyCopilotMeetingToEmail_Button);
            const tooltipText = loc(Strings_replyCopilotMeetingToEmail_Button_Tooltip);
            return {
                iconName: CalendarSparkleRegular,
                text: controlName,
                tooltip: tooltipText,
            };
        }

        case 552: {
            let controlName: string;
            let iconName: string;
            let tooltip: string | undefined;

            if (!props.isPopout && shouldShowMarkAllAsRead(mailboxInfo)) {
                controlName = loc(Strings_markAllAsRead_Button);
                iconName = MailReadMultipleRegular;
                tooltip = loc(StringsToolTip_markAllAsReadDesc);
            } else {
                controlName = loc(
                    isWin32StylingEnabled()
                        ? RibbonMailStrings_unreadRead_Button
                        : Strings_readUnread_Button
                );
                iconName = MailRead;
                tooltip = getHoverTooltip(controlId, controlName);
            }

            return {
                iconName,
                text: controlName,
                tooltip,
            };
        }

        case 509: {
            const controlName: string = loc(Strings_categorize_FlyoutButton);

            return {
                iconName: Tag,
                text: controlName,
                tooltip: getHoverTooltip(controlId, controlName),
            };
        }

        case 516: {
            const controlName: string = loc(Strings_createRule_Button);

            return {
                iconName: FolderMail,
                text: controlName,
                tooltip: getHoverTooltip(controlId, controlName),
            };
        }

        case 537: {
            const controlName: string = loc(Strings_manageRules_Button);

            return {
                iconName: Settings,
                text: controlName,
                tooltip: getHoverTooltip(controlId, controlName),
            };
        }

        //shared controls
        case 549: {
            const controlName: string = loc(Strings_printMail_Button);

            return {
                iconName: Print,
                text: controlName,
                tooltip: getHoverTooltip(controlId, controlName),
            };
        }

        case 532: {
            const controlName: string = loc(Strings_immersiveReader_Button);

            return {
                iconName: ImmersiveReader,
                text: controlName,
                tooltip: getHoverTooltip(controlId, controlName),
            };
        }

        case 616: {
            const controlName = loc(Strings_assignPolicy_FlyoutButton);

            const controlText =
                isSingleLineRibbon() || isWin32StylingEnabled()
                    ? controlName
                    : loc(Strings_assignPolicy_FlyoutButton_MLR);

            return {
                iconName: ArchiveSettings,
                text: controlText,
                tooltip: getHoverTooltip(controlId, controlName),
            };
        }

        case 539: {
            const controlName: string = loc(Strings_moreRetentionPoliciesOptions_Button);

            return {
                text: controlName,
                tooltip: getHoverTooltip(controlId, controlName),
            };
        }

        case 604: {
            const controlName: string = loc(FlagStrings_flagClearFlag_Button);

            return {
                text: controlName,
                tooltip: getHoverTooltip(controlId, controlName),
            };
        }

        case 598: {
            const controlName: string = loc(FlagStrings_flagCompleteToday_Button);

            return {
                text: controlName,
                tooltip: getHoverTooltip(controlId, controlName),
            };
        }

        case 599: {
            const controlName: string = loc(FlagStrings_flagCompleteTomorrow_Button);

            return {
                text: controlName,
                tooltip: getHoverTooltip(controlId, controlName),
            };
        }

        case 600: {
            const controlName: string = loc(FlagStrings_flagCompleteThisWeek_Button);

            return {
                text: controlName,
                tooltip: getHoverTooltip(controlId, controlName),
            };
        }

        case 601: {
            const controlName: string = loc(FlagStrings_flagCompleteNextWeek_Button);

            return {
                text: controlName,
                tooltip: getHoverTooltip(controlId, controlName),
            };
        }

        case 602: {
            const controlName: string = loc(FlagStrings_flagCompleteNoDate_Button);

            return {
                text: controlName,
                tooltip: getHoverTooltip(controlId, controlName),
            };
        }

        case 603: {
            const controlName: string = loc(FlagStrings_flagMarkComplete_Button);

            return {
                text: controlName,
                tooltip: getHoverTooltip(controlId, controlName),
            };
        }

        case 704: {
            const controlName: string = loc(FlagStrings_flagCompleteCustom_Button);

            return {
                text: controlName,
                tooltip: getHoverTooltip(controlId, controlName),
            };
        }

        case 732: {
            const controlName: string = loc(FlagStrings_flagAddReminder_Button);

            return {
                text: controlName,
                tooltip: getHoverTooltip(controlId, controlName),
            };
        }

        case 733: {
            const controlName: string = loc(FlagStrings_flagEditReminder_Button);
            return {
                text: controlName,
                tooltip: getHoverTooltip(controlId, controlName),
            };
        }

        case 527: {
            const controlName = loc(FlagStrings_flagUnflag_Button);
            const controlSplitBtn = loc(SplitButtonStrings_flagUnflag_SplitButton);

            const controlText = isWin32StylingEnabled()
                ? loc(FlagStrings_followUp_Button)
                : isSingleLineRibbon()
                ? controlName
                : loc(FlagStrings_flagUnflag_Button_MLR);

            return {
                iconName: Flag,
                text: controlText,
                ariaText: controlSplitBtn,
                tooltip: getHoverTooltip(controlId, controlName),
            };
        }

        case 572: {
            const controlName: string = loc(Strings_sweepEmail_Button);

            return {
                iconName: Broom,
                text: controlName,
                tooltip: getHoverTooltip(controlId, controlName),
            };
        }

        case 540: {
            const controlName = loc(Strings_move_FlyoutButton);

            const controlText = isSingleLineRibbon()
                ? controlName
                : loc(Strings_move_FlyoutButton_MLR);

            return {
                iconName: FolderArrowRight,
                text: controlText,
                tooltip: getHoverTooltip(controlId, controlName),
            };
        }

        case 686: {
            const controlName: string = loc(messageRecall);

            return {
                iconName: MailRewindRegular,
                text: controlName,
                tooltip: getHoverTooltip(controlId, controlName),
            };
        }

        case 688: {
            const controlName: string = loc(Strings_zoom_Button);

            return {
                iconName: ZoomInRegular,
                text: controlName,
                tooltip: getHoverTooltip(controlId, controlName),
            };
        }

        case 697: {
            const controlName: string = loc(trackReadReceipts);

            return {
                iconName: EyeFilled,
                text: controlName,
                tooltip: getHoverTooltip(controlId, controlName),
            };
        }

        case 702: {
            const controlName: string = loc(RibbonMailStrings_teams_ChatAroundEmailButton);

            return {
                iconName: ChatRegular,
                text: controlName,
                tooltip: getHoverTooltip(controlId, controlName),
            };
        }

        case 703: {
            const controlName: string = loc(RibbonMailStrings_teams_ChatAroundEmailAllButton);

            return {
                iconName: ChatRegular,
                text: controlName,
                tooltip: getHoverTooltip(controlId, controlName),
            };
        }

        case 709: {
            const controlName: string = loc(RibbonMailStrings_teams_ShareToTeamsChatButton);

            return {
                iconName: TeamsColor,
                text: controlName,
                tooltip: getHoverTooltip(controlId, controlName),
            };
        }

        case 705: {
            const controlName: string = loc(RibbonMailStrings_copyToButton);

            return {
                iconName: CopyArrowRightRegular,
                text: controlName,
                ariaText: controlName,
                tooltip: getHoverTooltip(controlId, controlName),
            };
        }

        case 712: {
            const controlName: string = loc(resend);

            return {
                iconName: MailArrowClockwiseRegular,
                text: controlName,
                ariaText: controlName,
                tooltip: getHoverTooltip(controlId, controlName),
            };
        }

        case 7016: {
            const controlName: string = loc(
                isWin32StylingEnabled()
                    ? RibbonMailStrings_allApps_Button
                    : Strings_getMessageExtensions_Button
            );

            return {
                iconName: AppFolderRegular,
                text: controlName,
                tooltip: getHoverTooltip(controlId, controlName),
            };
        }

        case 731: {
            const controlName: string = loc(RibbonMailStrings_Teams_ChatAroundEmailFlyoutButton);

            return {
                iconName: ChatRegular,
                text: controlName,
                tooltip: getHoverTooltip(controlId, controlName),
            };
        }

        case 652: {
            const controlName = loc(Strings_manageQuickSteps_Button);
            return {
                iconName: Settings,
                text: controlName,
                tooltip: getHoverTooltip(controlId, controlName),
            };
        }

        case 755: {
            const controlName = loc(RibbonMailStrings_createQuickStep_Button);
            return {
                iconName: AddRegular,
                text: controlName,
                tooltip: getHoverTooltip(controlId, controlName),
            };
        }

        case 550: {
            const controlName = loc(Strings_quickSteps_Button);
            const menuLauncherLabel = loc(Strings_quickSteps_MenuLauncherLabel);
            return {
                iconName: FlashRegular,
                text: controlName,
                ariaText: menuLauncherLabel,
                tooltip: getHoverTooltip(controlId, controlName),
            };
        }

        case 548: {
            const controlName = loc(Strings_pinUnpin_Button);

            const controlText = isSingleLineRibbon()
                ? controlName
                : loc(Strings_pinUnpin_Button_MLR);

            return {
                iconName: Unpin,
                text: controlText,
                tooltip: getHoverTooltip(controlId, controlName),
            };
        }

        case 571: {
            const controlName: string = loc(Strings_snooze_Button);

            return {
                iconName: Clock,
                text: controlName,

                tooltip: getHoverTooltip(controlId, controlName),
            };
        }

        case 531: {
            const controlName =
                getMailMenuItemShouldShow(20, mailboxInfo) ||
                !getMailMenuItemShouldShow(54, mailboxInfo)
                    ? loc(Strings_ignoreEmail_Button)
                    : loc(Strings_stopIgnoringEmail_Button);

            return {
                iconName: SpeakerMuteRegular,
                text: controlName,
                tooltip: getHoverTooltip(controlId, controlName),
            };
        }

        case 756: {
            const controlName: string = loc(RibbonMailStrings_scanButton);

            return {
                iconName: ShieldTaskRegular,
                text: controlName,
                tooltip: getHoverTooltip(controlId, controlName),
            };
        }

        default:
            /* eslint-disable-next-line owa-custom-rules/no-error-dynamic-event-names -- (https://aka.ms/OWALintWiki)
             * Error constructor names can only be a string literals.
             *	> Error constructor names can only be a string literals. Use the diagnosticInfo to add custom data. */
            throw new Error(
                'The ribbon id ' +
                    controlId +
                    ' was not added to the switch case in getSharedControlInfo.ts'
            );
    }
}

const shouldShowMarkAllAsRead = owaComputedFn(function shouldShowMarkAllAsRead(
    mailboxInfo: MailboxInfo
) {
    return getMailMenuItemShouldShow(23, mailboxInfo);
});
